import { render, staticRenderFns } from "./testPaper.vue?vue&type=template&id=163321fe&scoped=true"
import script from "./testPaper.vue?vue&type=script&lang=js"
export * from "./testPaper.vue?vue&type=script&lang=js"
import style0 from "./testPaper.vue?vue&type=style&index=0&id=163321fe&prod&lang=scss"
import style1 from "./testPaper.vue?vue&type=style&index=1&id=163321fe&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "163321fe",
  null
  
)

export default component.exports